/**
 * Do not edit directly
 */

export default "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTE2LjUgNy43ICAgICAgICAgICBMMTIgMy4yICAgICAgICAgICBMNy41IDcuNyAgICAgICAgICAgTDguNSA4LjcgICAgICAgICAgIEwxMS4yIDYgICAgICAgICAgIEwxMS4yIDE5LjcgICAgICAgICAgIEwxMi44IDE5LjcgICAgICAgICAgIEwxMi44IDYgICAgICAgICAgIEwxNS41IDguNyAgICAgICAgICAgWiIvPjwvc3ZnPg==";